<template>
  <v-touch class="day-cal__overlay">
    <div class="days-container" :style="{height: height + 'px'}">
      <div class="day">
        <day-cal
          @eventClicked="onTap"
          @lessonsUpdate="setScrollTop"
          :locale="locale"
          :i18n="i18n"
          :date="date"
          :events="lessons"
          :viewState="viewState">
        </day-cal>
      </div>
    </div>
  </v-touch>
</template>

<script>
  import dayCal from './DayCal.vue'

  export default{
    props: ['date', 'dateChange', 'viewState', 'locale', 'lessons', 'i18n'],
    components: {dayCal},
    data () {
      return {
        height: 300
      }
    },
    methods: {
      onTap (lesson) {
        this.$emit('eventClicked', lesson)
      },
      calculateHeightForCalendar () {
        let bottom = document.querySelector('.day-select__container').getBoundingClientRect().bottom
        let windowHeight = window.innerHeight
        this.height = windowHeight - bottom - 55
      },
      setScrollTop (val) {
        this.$el.scrollTop = val.top - 20
      }
    },
    mounted () {
      this.calculateHeightForCalendar()
      window.addEventListener('resize', () => {
        this.calculateHeightForCalendar()
      })
    }
  }
</script>

<style scoped>
  .day-cal__overlay {
    overflow-x: hidden;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
  }

  .days-container {
    position: relative;
    display: flex;
    height: 250px;
    width: 100%;
  }

  .days-container > .day {
    position: absolute;
    left: 0;
    right: 0;
  }

</style>



// WEBPACK FOOTER //
// CalContainer.vue?3b459540